(function () {
  if (window.__cartCountSyncInit) return;
  window.__cartCountSyncInit = true;

  var CART_ENDPOINT_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$|#)/i;
  var refreshTimer = null;

  function updateQtyPromo(itemCount) {
    var root = document.documentElement;
    var min = parseInt(root.getAttribute('data-qty-promo-min'), 10);
    if (!min) return;
    var n = Math.max(0, parseInt(itemCount, 10) || 0);
    root.classList.toggle('qty-promo-active', n >= min);
  }

  function updateCartCount(itemCount) {
    var n = Math.max(0, parseInt(itemCount, 10) || 0);
    updateQtyPromo(n);
    var elements = document.querySelectorAll('m-cart-count, .m-cart-count, .m-cart-count-bubble');
    elements.forEach(function (el) {
      el.textContent = n < 100 ? String(n) : '99+';
      if (n > 0) {
        el.classList.remove('m:hidden');
      } else {
        el.classList.add('m:hidden');
      }
    });
  }

  function refreshFromCart() {
    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') {
          updateCartCount(cart.item_count);
        }
      })
      .catch(function () {});
  }

  function scheduleRefresh(delay) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshFromCart, delay || 80);
  }

  // Hook fetch for cart endpoints
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function () {
      var args = arguments;
      var url = '';
      try {
        var first = args[0];
        url = typeof first === 'string' ? first : (first && first.url) || '';
      } catch (_) {}
      var promise = origFetch.apply(this, args);
      if (url && CART_ENDPOINT_RE.test(url)) {
        promise.then(function () { scheduleRefresh(80); }, function () {});
      }
      return promise;
    };
  }

  // Hook XHR for cart endpoints
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__ccsUrl = url;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var url = this.__ccsUrl;
    if (url && CART_ENDPOINT_RE.test(url)) {
      this.addEventListener('load', function () { scheduleRefresh(80); });
    }
    return origSend.apply(this, arguments);
  };

  // Theme events (Minimog drawer)
  document.addEventListener('cart:updated', function (e) {
    var cart = e && e.detail && e.detail.cart;
    if (cart && typeof cart.item_count === 'number') {
      updateCartCount(cart.item_count);
    } else {
      scheduleRefresh(50);
    }
  });
  document.addEventListener('cart:refresh', function () {
    scheduleRefresh(150);
  });

  if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents && window.MinimogTheme.pubSubEvents.cartUpdate) {
    try {
      window.MinimogEvents.subscribe(
        window.MinimogTheme.pubSubEvents.cartUpdate,
        function (data) {
          if (data && data.cart && typeof data.cart.item_count === 'number') {
            updateCartCount(data.cart.item_count);
          } else {
            scheduleRefresh(50);
          }
        }
      );
    } catch (_) {}
  }

  // Sanity refresh on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scheduleRefresh(800); });
  } else {
    scheduleRefresh(800);
  }
})();
